import React from 'react';
import PropTypes from 'prop-types';
import { API_BASE_URL } from '../../utils/apiClient';
import './EmulatorJS.css';

const EmulatorJS = ({ game, platform, selectedRomVersion }) => {
  // Use the ROM path already selected in the game object
  // Use activeRom if available (set in Feed.js) to ensure we're using the correct ROM path
  const romToUse = game.activeRom || game.rom;
  
  // Use loadasname if available, otherwise use the original rom path
  let romPath;
  // Only use temp path for MAME cores
  const usesTempPath = platform.emulatoroptions === 'mame' && game.loadasname;
  
  if (usesTempPath) {
    // For MAME cores with loadasname, we need to use the temp path
    // The ROM version suffix (_jpn, _chn, etc.) should already be handled in Game.js
    romPath = `/roms/temp/${game.id}/${game.loadasname}`;
    
    // Check if we need to add a suffix based on the version
    if (selectedRomVersion === 'japanese' || selectedRomVersion === 'version-1') {
      const loadasname = game.loadasname;
      const extPos = loadasname.lastIndexOf('.');
      if (extPos !== -1) {
        romPath = `/roms/temp/${game.id}/${loadasname.substring(0, extPos)}_jpn${loadasname.substring(extPos)}`;
      } else {
        romPath = `/roms/temp/${game.id}/${loadasname}_jpn`;
      }
    } else if (selectedRomVersion === 'chinese' || selectedRomVersion === 'version-2') {
      const loadasname = game.loadasname;
      const extPos = loadasname.lastIndexOf('.');
      if (extPos !== -1) {
        romPath = `/roms/temp/${game.id}/${loadasname.substring(0, extPos)}_chn${loadasname.substring(extPos)}`;
      } else {
        romPath = `/roms/temp/${game.id}/${loadasname}_chn`;
      }
    } else if (selectedRomVersion === 'multiplayer') {
      const loadasname = game.loadasname;
      const extPos = loadasname.lastIndexOf('.');
      if (extPos !== -1) {
        romPath = `/roms/temp/${game.id}/${loadasname.substring(0, extPos)}_mp${loadasname.substring(extPos)}`;
      } else {
        romPath = `/roms/temp/${game.id}/${loadasname}_mp`;
      }
    }
    
    console.log(`Using temp path with loadasname: ${romPath}`);
  } else {
    // For other emulators or without loadasname, use the direct ROM path
    romPath = romToUse;
    console.log(`Using direct ROM path: ${romPath}`);
  }
  
  return (
    <iframe
      src={`/ejs.html?core=${platform.emulatoroptions}&rom=${encodeURIComponent(`${API_BASE_URL}${romPath}`)}&platformId=${platform.id}`}
      title={game.titleeng || game.titlechn}
      className="emulator-frame"
      allow="autoplay"
      allowFullScreen
    />
  );
};

EmulatorJS.propTypes = {
  game: PropTypes.object.isRequired,
  platform: PropTypes.object.isRequired,
  selectedRomVersion: PropTypes.string.isRequired
};

export default EmulatorJS; 